import { render, staticRenderFns } from "./CallsGiftsReport.vue?vue&type=template&id=a9bf5d34&scoped=true"
import script from "./CallsGiftsReport.vue?vue&type=script&lang=js"
export * from "./CallsGiftsReport.vue?vue&type=script&lang=js"
import style0 from "./CallsGiftsReport.vue?vue&type=style&index=0&id=a9bf5d34&prod&lang=scss"
import style1 from "./CallsGiftsReport.vue?vue&type=style&index=1&id=a9bf5d34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9bf5d34",
  null
  
)

export default component.exports